import { Dialog } from "@kobalte/core/dialog";
import { A } from "@solidjs/router";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbHelpCircleFilled, TbSparkles, TbX } from "solid-icons/tb";
import { useWire } from "~/wire";

export const InsufficientCreditsModal = () => {
  const wire = useWire();
  return (
    <AnimateChildren
      show={wire.ui.creditsGate.isModalOpen()}
      enter={{ opacity: [0, 1], y: [10, 0] }}
      exit={{ opacity: [1, 0], y: [0, 10] }}
    >
      {(anim) => (
        <Dialog
          open={anim.isMounted()}
          onOpenChange={(val) => {
            if (!val) wire.ui.creditsGate.closeModal();
          }}
        >
          <Dialog.Portal>
            <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10" />
            <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
              <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-xl bg-panel overflow-y-auto rounded-xl p-8">
                <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                  <TbX />
                </Dialog.CloseButton>
                <h3 class="text-lg font-medium mb-6">{wire.ui.creditsGate.description()}</h3>

                <p class="mb-2">
                  Your current balance is: <span class="font-medium">{wire.billing.credits()} credits</span>
                </p>
                <p class="mb-4 text-sm">
                  Top up or wait for credits to be refilled.{" "}
                  <a
                    class="inline-flex items-center gap-1 underline text-brand text-xs"
                    href="https://go.storytell.ai/learn-credits#ce1kqk85oik"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <TbHelpCircleFilled />
                    Learn more
                  </a>
                </p>

                <StButton
                  as={A}
                  icon={TbSparkles}
                  href="/pricing"
                  onClick={() => wire.ui.creditsGate.closeModal()}
                  class="text-sm max-w-32 ml-auto px-3 py-2 text-on-brand bg-brand hover:bg-brand-hover"
                >
                  Top up
                </StButton>
              </Dialog.Content>
            </div>
          </Dialog.Portal>
        </Dialog>
      )}
    </AnimateChildren>
  );
};
